import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView";
import i18n from "i18next";
import { ReclamationOperationApi } from "src/api/generated/erp/reclamations/api/reclamationOperationApi.ts";
import { OpenFormInputDialogFunc } from "src/components/common/dialogs/formInput/useFormInput.tsx";
import { FormAsyncUserSelectField } from "src/components/views/users/FormAsyncUserSelectField.tsx";
import { FormCheckbox } from "src/components/common/forms/fields/FormCheckbox.tsx";

interface ReleaseReclamationFormValues {
	workerUserId: number | null;
	releaseTasks: boolean;
}

export const getReclamationCustomerOrderLabel = (reclamation: ReclamationView) => {
	if (reclamation.customerOrderId != null) {
		return `${reclamation.customerOrderId} | ${reclamation.customerOrderReference}`;
	} else return "-";
};

export async function releaseReclamation(
	{ showFormInput, reclamationIds, currentWorkerUserId, afterReleased }: {
		showFormInput: OpenFormInputDialogFunc,
		reclamationIds: number[],
		currentWorkerUserId: number | null | undefined,
		afterReleased?: () => Promise<unknown>
	},
) {
	const result = await showFormInput<ReleaseReclamationFormValues>({
		title: i18n.t("release_reclamation"),
		defaultValues: {
			workerUserId: currentWorkerUserId ?? null,
			releaseTasks: true,
		},
		content: ({ control }) => (
			<>
				<FormAsyncUserSelectField control={control} name={"workerUserId"} label={i18n.t("worker")} />
				<FormCheckbox control={control} name={"releaseTasks"} label={i18n.t("release_tasks_too")} />
			</>
		),
	});
	if (result == null) return;

	await ReclamationOperationApi.releaseReclamation({
		reclamationIds: reclamationIds,
		releaseTasks: result.releaseTasks,
		workerUserId: result.workerUserId,
	});
	await afterReleased?.();
}
